<template>
  <div class="flex flex-col gap-2 p-4">
    <div class="font-medium uppercase">
      <FontAwesomeIcon :icon="faBolt" />
      {{ $t('components.projects.statusTaskControl.workInProgress.title') }}
    </div>
    <div v-if="currentUser.roles.includes('admin:skyloud')">
      <p class="text-sm">{{ $t('components.projects.statusTaskControl.workInProgress.wip') }} 🧑‍💻</p>
      <WaitingButtonsControl :task="task" />
    </div>
    <p
      v-else
      class="mt-2 text-sm"
    >
      {{ $t('components.projects.statusTaskControl.workInProgress.workingOnRequest') }}
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { faBolt } from '@fortawesome/pro-light-svg-icons';
import WaitingButtonsControl from '@/modules/projects/components/TaskControls/WaitingButtonsControl.vue';

defineProps({
  task: {
    type: Object,
    required: true,
  },
});

const store = useStore();

const currentUser = computed(() => store.getters['auth/currentUser']);
</script>
